import { render, staticRenderFns } from "./ScriptTaskList.vue?vue&type=template&id=3c220b9e&"
import script from "./ScriptTaskList.vue?vue&type=script&lang=js&"
export * from "./ScriptTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports